import styled from "@emotion/styled";
import { Empty, GroupA } from "@src/ruix";

export const AboutContentsMobile = () => (
	<MainContentsContainer className="column-center-start">
		<MainSection />
		<TrustSection />
		<OurJourneySection />
		<CofounderSection />
		<Empty space={12} />
	</MainContentsContainer>
);

const MainContentsContainer = styled.div`
	gap: 80px;
`;
const ContentsContainer = styled.section`
	width: 100%;
	max-width: 768px;
	padding: 0 10px;
	position: relative;
`;

const MainSection = () => (
	<ContentsContainer
		className="column-center-start"
		style={{
			padding: "60px 20px",
		}}
	>
		<GroupA order="column-start-start" gap={40}>
			<GroupA order="column-start-start" gap={10}>
				<MainTitle>{`원포인트의 본질은\n매칭도 고용도 아닙니다`}</MainTitle>
				<MainSubTitle>신뢰입니다</MainSubTitle>
			</GroupA>
			<GroupA order="column-start-start" gap={20}>
				<GroupA order="column-start-start" gap={12}>
					<MainDescription>{`세상에는 잠재력 높은 작은 기업이 너무 많습니다\n좋은 인재와 함께 한다면 빠르게 성장할 수 있는데, 현실적으로 어렵습니다`}</MainDescription>
					<MainDescription>{`저희 롸잇은 어렵지만 너무 중요한 이 문제를 해결하고 싶고,\n검증된 인재를 파트타임으로 고용할 수 있게 돕는 것이 그 시작입니다`}</MainDescription>
				</GroupA>
				<MainSubDescription>{`외부 인재와의 협업이기 때문에 조심스러울 수 밖에 없습니다\n조금이라도 더 마음편히 고용하고, 성장하실 수 있도록 저희 팀 매일 정진하겠습니다`}</MainSubDescription>
				<MainDescriptionTitle>{`신뢰를 최우선시 하겠습니다\n항상 올바른 가치를 추구하고 정직하게 일하겠습니다`}</MainDescriptionTitle>
			</GroupA>
		</GroupA>
	</ContentsContainer>
);

const MainTitle = styled.h1`
	color: var(--card-bg);
	font-family: Pretendard;
	font-size: 32px;
	font-style: normal;
	font-weight: 800;
	line-height: 116%;
	letter-spacing: -1.6px;
	margin: 0;

	@media (min-width: 600px) {
		font-size: 40px;
	}
`;

const MainSubTitle = styled.div`
	font-family: Pretendard;
	font-size: 64px;
	font-style: normal;
	font-weight: 800;
	line-height: 116%;
	letter-spacing: -2.88px;

	@media (min-width: 600px) {
		font-size: 72px;
	}
`;

const MainDescription = styled.div`
	color: var(--desc-gray);
	font-family: Pretendard;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
	letter-spacing: -0.8px;
	word-break: keep-all;
	overflow-wrap: break-word;

	@media (min-width: 600px) {
		font-size: 20px;
		padding: 0 12px;
	}
`;

const MainSubDescription = styled.div`
	color: var(--desc-gray);
	font-family: Pretendard;
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%;
	letter-spacing: -0.96px;
	word-break: keep-all;
	overflow-wrap: break-word;

	@media (min-width: 600px) {
		font-size: 24px;
		padding: 0 12px;
	}
`;

const MainDescriptionTitle = styled.div`
	color: var(--card-bg);
	font-family: Pretendard;
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%;
	letter-spacing: -1.2px;
	word-break: keep-all;
	overflow-wrap: break-word;

	@media (min-width: 600px) {
		font-size: 40px;
		padding: 0 12px;
	}
`;

const TrustSection = () => {
	const TrustData = [
		{
			title: "누적 고객사",
			num: "500+",
			numstr: "개",
			dest: "전문가를 1회 이상 고용한 고객사 수",
		},
		{
			title: "누적 전문가",
			num: "700+",
			numstr: "명",
			dest: "3단계 검증을 거쳐 합격한 전문가 수",
		},
		{
			title: "계약 연장",
			num: "80",
			numstr: "%",
			dest: "매월 계약을 연장하는 기업의 비율",
		},
	];

	return (
		<ContentsContainer className="column-center-start">
			<TitleDiv>주요 성과</TitleDiv>
			<Empty space={24} />
			<GroupA order="row-start-center" gap={8}>
				{TrustData.map((data, index) => (
					<TrustCard key={index} className="column-center-center">
						<div className="title">{data.title}</div>
						<GroupA order="row-center-center" gap={0} fullWidth>
							<div className="num">{data.num}</div>
							<div className="numstr">{data.numstr}</div>
						</GroupA>
						<div className="desc">{data.dest}</div>
					</TrustCard>
				))}
			</GroupA>
		</ContentsContainer>
	);
};

const TitleDiv = styled.div`
	color: var(--card-bg);
	font-family: Pretendard;
	font-size: 32px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;

	@media (min-width: 600px) {
		font-size: 40px;
	}
`;

const TrustCard = styled.div`
	display: flex;
	width: 320px;
	padding: 40px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	border-radius: 4px;
	background: #f8f9fb;

	.title {
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 36px */
		letter-spacing: -0.96px;
		width: 100%;
	}

	.num {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 40px;
		font-style: normal;
		font-weight: 800;
		line-height: 116%; /* 55.68px */
		letter-spacing: -1.92px;
	}

	.numstr {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 800;
		line-height: 130%; /* 41.6px */
		letter-spacing: -1.28px;
	}

	.desc {
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
		width: 100%;
	}

	@media (min-width: 600px) {
		.title {
			font-size: 24px;
		}

		.num {
			font-size: 48px;
		}

		.numstr {
			font-size: 32px;
		}

		.desc {
			font-size: 20px;
		}
	}
`;

const OurJourneySection = () => {
	const JourneyData = [
		{
			year: "2022",
			monthData: [
				{
					month: 7,
					title: "법인 설립",
				},
				{
					month: 8,
					title: "시드 투자",
				},
				{
					month: 11,
					title: "업무 스코핑 컨설팅 도입",
				},
			],
		},
		{
			year: "2023",
			monthData: [
				{
					month: 5,
					title: "TIPS 선정",
				},
				{
					month: 7,
					title: "전문가 교육 시스템 구축",
				},
				{
					month: 8,
					title: "지원자 동료평가 시스템 구축",
				},
				{
					month: 12,
					title: "최적매칭 VQ 시스템화",
				},
			],
		},
		{
			year: "2024",
			monthData: [
				{
					month: 5,
					title: "최적 매칭 알고리즘 고도화",
				},
				{
					month: 8,
					title: "전문가 검증 자동화 솔루션 도입",
				},
			],
		},
	];

	return (
		<ContentsContainer className="column-center-start">
			<TitleDiv>걸어온 길</TitleDiv>
			<Empty space={24} />
			<GroupA fullWidth order="column-center-start" gap={32}>
				{JourneyData.map((data, index) => (
					<JourneyCard key={index}>
						<div className="card">
							<div className="year">{data.year}</div>
							<GroupA order="column-start-start" gap={0}>
								{data.monthData.map((monthData, index) => (
									<div className="row-start-start month-data" key={index}>
										<div className="month">{monthData.month}월</div>
										<div className="title">{monthData.title}</div>
									</div>
								))}
							</GroupA>
						</div>
						<div className={`line-${index}`}></div>
					</JourneyCard>
				))}
			</GroupA>
		</ContentsContainer>
	);
};

const JourneyCard = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 20px;

	.card {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 20px;
	}

	.year {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 800;
		line-height: 130%; /* 41.6px */
		letter-spacing: -1.28px;
		padding-top: 4px;
	}

	.month {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
		margin-right: 16px;
		width: 3ch;
		text-align: right;
	}

	.title {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%;
		letter-spacing: -0.8px;
	}

	.month-data {
		width: 230px;
	}

	.line-0,
	.line-1 {
		width: 110%;
		height: 4px;
		flex-shrink: 0;
		background: #f8f9fb;
	}

	@media (min-width: 600px) {
		.card {
			display: flex;
			flex-direction: row;
			align-items: start;
			justify-content: start;
			width: 385px;
		}

		.year {
			padding-top: 0;
			font-size: 32px;
		}

		.month {
			font-size: 20px;
		}

		.title {
			font-size: 20px;
		}

		.month-data {
			width: 100%;
		}
	}
`;

const CofounderSection = () => {
	const CofounderData = [
		{
			name: "최준순",
			position: "Co-Founder&CEO",
			school: "연세대학교 졸업",
			career: ["前 AT커니 컨설턴트", "前 인터브랜드 컨설턴트"],
			image: "/onepoint/images/renewal/about/junsoon.png",
		},
	];

	return (
		<ContentsContainer className="column-center-start" style={{ padding: "0 32px" }}>
			<TitleDiv>만든 사람</TitleDiv>
			<Empty space={24} />
			<GroupA order="row-start-center" gap={40}>
				{CofounderData.map((data, index) => (
					<CofounderCard key={index} className="column-start-start">
						<img
							className="img"
							style={{
								aspectRatio: "1/1",
								objectFit: "cover",
							}}
							src={data.image}
						/>
						<Empty space={20} />
						<div className="name">{data.name}</div>
						<div className="position">{data.position}</div>
						<Empty space={12} />
						<div className="desc">{data.school}</div>
						<Empty space={12} />
						{data.career.map((career, index) => (
							<div key={index} className="desc">
								{career}
							</div>
						))}
					</CofounderCard>
				))}
			</GroupA>
		</ContentsContainer>
	);
};

const CofounderCard = styled.div`
	min-width: 300px;
	width: calc(50% - 20px);

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%;
		letter-spacing: -1.28px;
	}

	.position {
		color: var(--card-bg);
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%;
		letter-spacing: -0.8px;
	}

	.desc {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%;
		letter-spacing: -0.8px;
	}

	.img {
		width: 100%;
	}

	@media (min-width: 600px) {
		.name {
			font-size: 32px;
		}

		.position {
			font-size: 20px;
		}

		.desc {
			font-size: 20px;
		}
	}
`;
